import { TBC } from './tbc';
import { removeUndefinedAndNullOptions, clearObject } from '@shared/utils/util';

export class TBCSerializer {

  fromJson(json: any): TBC {

    const tbc = new TBC();

    tbc.success = json.success;
    tbc.data = this.toJson(json.data);
    return tbc;
  }

  toJson(tbc: TBC): any {
    if (typeof tbc === 'object') {
      const obj = {
        id: tbc.id,
        tbc: tbc.tbc,
        totvs_user: tbc.totvs_user,
        totvs_pass: tbc.totvs_pass,
        cascade_change: tbc.cascade_change,
        changed_by: tbc.changed_by,
        last_change: tbc.last_change,
        use_methods_without_license: tbc.use_methods_without_license,
        use_totvs_oracle: tbc.use_totvs_oracle,
        cod_coligate: tbc.cod_coligate,
        cod_system: tbc.cod_system,
        cod_affiliate: tbc.cod_affiliate,
        cod_user: tbc.cod_user,
        cod_course_type: tbc.cod_course_type,
        use_methods_rest: tbc.use_methods_rest
      };
      return clearObject(obj);
    } else {
      return tbc;
    }
  }
}
